import React, { useRef, useEffect, useState,useContext } from 'react';
import  { QrReader } from 'react-qr-reader';
import "./QRScannerComponent.css";
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import { AppContext } from '../../AppContext';
import { useNavigate } from 'react-router-dom';


const QRScannerComponent = () => {
    var { setQrGlobalData} = useContext(AppContext);
    const [qrData,setQrData] = useState('');
    const qrScannerRef = useRef(null);
    const navigate = useNavigate();


    const handleScan = (qrData) => {
        var secondPart = '';

        if (qrData) {
            try {
       
                const splitText = qrData.text.split('/');
                //const firstPart = splitText[0]; // "Hello"
                secondPart = splitText[1]; // "World"
                setQrData(secondPart);
                setQrGlobalData(secondPart);
            } catch (error) {   
            }
        }
    };

    const handleError = (error) => {
        console.error(error);
    };


    useEffect(() => {
      if (qrData) {
          navigate(`/${qrData}`);
      }
  }, [navigate, qrData]);

    useEffect(() => {
        // Dodaj klasę CSS do elementu <body> po zamontowaniu komponentu
        document.body.classList.add('custom-body-style');


        // Usuń klasę CSS z elementu <body> po odmontowaniu komponentu
        return () => {
            document.body.classList.remove('custom-body-style');
        };
    }, []);


    return (
        <Container maxWidth="lg" >
            <Grid container spacing={2} alignItems="center" // Ustawienie zawartości w pionie na środku ekranu
                justifyContent="center" style={{ minHeight: '50px' }}>
                <Grid item xs={12} sm={12}>
                <div className="element-hello" style={{ textAlign: 'center', paddingTop: '30px' }}><svg xmlns="http://www.w3.org/2000/svg" width="53" height="59" viewBox="0 0 53 59" fill="none">
                        <path d="M3.11109 11.7245H12.4444V52.079C12.4428 52.9073 12.6433 53.7223 13.0271 54.4472C13.4109 55.172 13.9652 55.7827 14.6377 56.2217C16.0844 57.2127 16.7688 58.8373 19.1799 58.8373C22.5554 58.8373 22.5554 55.5881 25.9154 55.5881C29.2754 55.5881 29.2909 58.8373 32.6509 58.8373C36.0109 58.8373 36.0265 55.5881 39.402 55.5881C42.7775 55.5881 42.762 58.8373 46.1375 58.8373C48.5642 58.8373 49.2486 57.2127 50.6953 56.2217C51.3678 55.7827 51.9221 55.172 52.3059 54.4472C52.6896 53.7223 52.8902 52.9073 52.8886 52.079V8.47531C52.8886 6.32098 52.0692 4.25489 50.6105 2.73155C49.1519 1.20821 47.1736 0.352407 45.1109 0.352407H7.77773C7.25511 0.347324 6.7335 0.401799 6.22219 0.514865C4.46541 0.88938 2.88648 1.88631 1.75263 3.33692C0.618771 4.78753 -0.000365788 6.60273 1.62132e-07 8.47531C1.62132e-07 9.33704 0.327775 10.1635 0.911218 10.7728C1.49466 11.3821 2.28598 11.7245 3.11109 11.7245ZM45.1109 3.60157C46.3485 3.60157 47.5355 4.11505 48.4107 5.02905C49.2858 5.94305 49.7775 7.18271 49.7775 8.47531V52.079C49.7764 52.3567 49.7072 52.6294 49.5765 52.8711C49.4458 53.1128 49.2579 53.3156 49.0308 53.4599C48.45 53.8651 47.9035 54.3217 47.3975 54.8246C46.6353 55.5556 46.5575 55.5881 46.1375 55.5881C45.7175 55.5881 45.6397 55.5881 44.8775 54.8246C44.1757 54.0538 43.3312 53.4402 42.3952 53.0208C41.4593 52.6015 40.4515 52.3853 39.4331 52.3853C38.4147 52.3853 37.4069 52.6015 36.471 53.0208C35.5351 53.4402 34.6905 54.0538 33.9887 54.8246C33.2265 55.5556 33.1487 55.5881 32.7287 55.5881C32.3087 55.5881 32.2465 55.5881 31.4843 54.8246C30.7824 54.0538 29.9379 53.4402 29.002 53.0208C28.0661 52.6015 27.0583 52.3853 26.0399 52.3853C25.0214 52.3853 24.0136 52.6015 23.0777 53.0208C22.1418 53.4402 21.2973 54.0538 20.5954 54.8246C19.8332 55.5556 19.7554 55.5881 19.3354 55.5881C18.9155 55.5881 18.8532 55.5881 18.091 54.8246C17.5882 54.3178 17.0414 53.861 16.4577 53.4599C16.2306 53.3156 16.0428 53.1128 15.9121 52.8711C15.7813 52.6294 15.7121 52.3567 15.711 52.079V8.47531C15.7137 6.79015 15.3577 5.12543 14.6688 3.60157H45.1109ZM6.56441 3.76402H6.89107C7.18105 3.68074 7.47793 3.62634 7.77773 3.60157C9.01276 3.59839 10.1986 4.10664 11.0755 5.01495C11.7186 5.69972 12.1612 6.56207 12.351 7.50056C12.3983 7.82356 12.4295 8.14892 12.4444 8.47531H3.11109C3.11001 7.40257 3.44784 6.35942 4.0722 5.50762C4.69656 4.65581 5.57258 4.04294 6.56441 3.76402Z" fill="#FF7A00" />
                        <path d="M35.7776 13.349H45.1108C45.5234 13.349 45.9191 13.1779 46.2108 12.8732C46.5025 12.5685 46.6664 12.1553 46.6664 11.7245C46.6664 11.2936 46.5025 10.8804 46.2108 10.5757C45.9191 10.271 45.5234 10.0999 45.1108 10.0999H35.7776C35.365 10.0999 34.9693 10.271 34.6776 10.5757C34.3859 10.8804 34.222 11.2936 34.222 11.7245C34.222 12.1553 34.3859 12.5685 34.6776 12.8732C34.9693 13.1779 35.365 13.349 35.7776 13.349Z" fill="#FF7A00" />
                        <path d="M35.7776 19.8474H45.1108C45.5234 19.8474 45.9191 19.6762 46.2108 19.3715C46.5025 19.0669 46.6664 18.6537 46.6664 18.2228C46.6664 17.7919 46.5025 17.3787 46.2108 17.074C45.9191 16.7694 45.5234 16.5982 45.1108 16.5982H35.7776C35.365 16.5982 34.9693 16.7694 34.6776 17.074C34.3859 17.3787 34.222 17.7919 34.222 18.2228C34.222 18.6537 34.3859 19.0669 34.6776 19.3715C34.9693 19.6762 35.365 19.8474 35.7776 19.8474Z" fill="#FF7A00" />
                        <path d="M35.7776 26.3457H45.1108C45.5234 26.3457 45.9191 26.1745 46.2108 25.8698C46.5025 25.5652 46.6664 25.1519 46.6664 24.7211C46.6664 24.2902 46.5025 23.877 46.2108 23.5723C45.9191 23.2677 45.5234 23.0965 45.1108 23.0965H35.7776C35.365 23.0965 34.9693 23.2677 34.6776 23.5723C34.3859 23.877 34.222 24.2902 34.222 24.7211C34.222 25.1519 34.3859 25.5652 34.6776 25.8698C34.9693 26.1745 35.365 26.3457 35.7776 26.3457Z" fill="#FF7A00" />
                        <path d="M20.2221 34.4686H45.1109C45.5234 34.4686 45.9191 34.2974 46.2108 33.9928C46.5025 33.6881 46.6664 33.2749 46.6664 32.844C46.6664 32.4131 46.5025 31.9999 46.2108 31.6952C45.9191 31.3906 45.5234 31.2194 45.1109 31.2194H20.2221C19.8096 31.2194 19.4139 31.3906 19.1222 31.6952C18.8305 31.9999 18.6666 32.4131 18.6666 32.844C18.6666 33.2749 18.8305 33.6881 19.1222 33.9928C19.4139 34.2974 19.8096 34.4686 20.2221 34.4686Z" fill="#FF7A00" />
                        <path d="M20.2221 40.9669H45.1109C45.5234 40.9669 45.9191 40.7957 46.2108 40.4911C46.5025 40.1864 46.6664 39.7732 46.6664 39.3423C46.6664 38.9115 46.5025 38.4982 46.2108 38.1936C45.9191 37.8889 45.5234 37.7177 45.1109 37.7177H20.2221C19.8096 37.7177 19.4139 37.8889 19.1222 38.1936C18.8305 38.4982 18.6666 38.9115 18.6666 39.3423C18.6666 39.7732 18.8305 40.1864 19.1222 40.4911C19.4139 40.7957 19.8096 40.9669 20.2221 40.9669Z" fill="#FF7A00" />
                        <path d="M21.7777 26.3457H27.9999C28.825 26.3457 29.6163 26.0034 30.1997 25.394C30.7832 24.7847 31.111 23.9583 31.111 23.0965V13.349C31.111 12.4873 30.7832 11.6609 30.1997 11.0515C29.6163 10.4422 28.825 10.0999 27.9999 10.0999H21.7777C20.9526 10.0999 20.1613 10.4422 19.5778 11.0515C18.9944 11.6609 18.6666 12.4873 18.6666 13.349V23.0965C18.6666 23.9583 18.9944 24.7847 19.5778 25.394C20.1613 26.0034 20.9526 26.3457 21.7777 26.3457ZM21.7777 13.349H27.9999V23.0965H21.7777V13.349Z" fill="#FF7A00" />
                    </svg></div>
                </Grid>
            </Grid>
            <Grid container spacing={2} alignItems="center" // Ustawienie zawartości w pionie na środku ekranu
                justifyContent="center" style={{ minHeight: '80px' }}>
                <Grid item xs={12} sm={12}>
                    <div className="element-info" style={{ textAlign: 'center', paddingTop: '11px' }}>Zeskanuj kod QR z wydruku</div>
                </Grid>
            </Grid>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={2} sm={2}></Grid>
                <Grid item xs={8} sm={8}>
                    <Box border="2px solid #000" borderRadius="2px">
                        <QrReader
                            //ref={qrScannerRef}
                            constraints={{facingMode: 'environment'}}
                            scanDelay={300}
                            onResult={handleScan}
                            videoStyle={{ textAlign: 'center', width: '100%' }}
                            />
                    </Box>
                    <Grid item xs={2} sm={2}></Grid>
                </Grid>
            </Grid>
            <div>{qrData}</div>

        </Container>



    );
};

export default QRScannerComponent;





